import { useAuth0 } from '@auth0/auth0-react';
import { DialogWithForm } from '@strata/react-dialog';
import { TextInputFormik } from '@strata/react-inputs';
import { SuccessToast } from '@strata/react-toast-message';
import { validationStrings } from '@strata/strata-ui-strings';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { createNote } from 'api/medbillingAPI';
import { handleError } from 'services/Error';

const ValidationSchema = Yup.object({
    subject: Yup.string().required(validationStrings.requiredField.errorMessage),
});

interface NewNoteDialogProps {
    isOpen: boolean;
    payerId: string;
    transactionId: string;
    onCreateSuccess: (newConversationId: string) => void;
    onCancel: () => void;
}

export const NewNoteDialog = ({
    isOpen,
    payerId,
    transactionId,
    onCreateSuccess,
    onCancel,
}: NewNoteDialogProps) => {
    const { user } = useAuth0();
    return (
        <Formik
            initialValues={{} as Yup.InferType<typeof ValidationSchema>}
            validationSchema={ValidationSchema}
            enableReinitialize
            onSubmit={async ({ subject }, { resetForm }) => {
                try {
                    const newConversationId = await createNote({
                        payerId,
                        transactionId,
                        details: {
                            details: { subject },
                            created_by_first_name: user?.given_name,
                            created_by_last_name: user?.family_name,
                        },
                    });
                    SuccessToast({ message: `New note created: ${subject}.` });
                    onCreateSuccess(newConversationId);
                    resetForm();
                } catch (err) {
                    handleError('Unable to create a new note.', err as Error);
                }
            }}
        >
            {(formik) => (
                <DialogWithForm
                    isOpen={isOpen}
                    dialogTitle="Create Note"
                    isPrimaryButtonDisabled={
                        !(formik.dirty && formik.isValid) || formik.isSubmitting
                    }
                    onSecondaryButtonClick={() => {
                        onCancel();
                        formik.resetForm();
                    }}
                    primaryButtonLabel="Create Note"
                    secondaryButtonLabel="Cancel"
                    dialogContent={<TextInputFormik id="subject" label="Note Summary" required />}
                />
            )}
        </Formik>
    );
};
